import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import AlertMessage from 'components/AlertMessage';
import classnames from 'classnames';

import { SIGN_IN_PATH } from 'routes';

import * as actions from 'store/modules/auth/actions';

import { HeaderUnLoggedIn } from 'scenes/Header';
import FooterRegistration from 'components/FooterRegistration';
import UserFormSignUp from './UserFormSignUp';
import getUrlParam from 'helpers/getUrlParam';
import getTrialLinkExpireDate from './helpers/getTrialLinkExpireDate';
import { getUrl } from 'helpers/getUrl';

import ReactPixel from 'react-facebook-pixel';

class SignUp extends Component {
  state = {
    showAlertSuccess: false,
    showAlertError: false,
    alertTextSuccess: '',
    alertTextError: '',
    link_days: null,
  };

  async componentDidMount(){
    ReactPixel.track('Lead');
    if (this.getTrialToken() !== null) {
      const result = await getTrialLinkExpireDate({access_token: this.getTrialToken()})
      this.setState({link_days: result.data.trial_days})
    }
  }

  hideAlert = () => {
    this.setState({
      showAlertSuccess: false,
    });
  };

  getTrialToken = () => {
    if (localStorage.getItem('trialToken') === 'null') {return null}
    return localStorage.getItem('trialToken')
  }

  handleRegister = async (values, setSubmitting, setErrors) => {
    const expectedAccounts = getUrlParam('accounts')
      ? getUrlParam('accounts')
      : null;
    const expectedPlan = getUrlParam('plan') ? getUrlParam('plan') : null;
    if (expectedPlan && expectedAccounts) {
      localStorage.setItem('expected_plan', expectedPlan);
      localStorage.setItem('expected_accounts', expectedAccounts);
    }
    const response = await this.props.signUpAction(
      values.full_name,
      values.email,
      values.password,
      values.agreeToTerms,
      values.receiveEmail,
      getUrlParam('reservation_token'),
      this.getTrialToken(),
      expectedAccounts,
      expectedPlan,
      setSubmitting,
      setErrors,
    );
    if (response.status !== 200) {
      this.setState({ showAlertError: true });
      this.setState({ alertTextError: response.error });
      setTimeout(() => {
        this.setState({ showAlertError: false });
      }, 4000);
    } else {
      ReactPixel.track('CompleteRegistration');
    }
  };

  render() {
    const {
      showAlertSuccess,
      showAlertError,
      alertTextSuccess,
      alertTextError,
    } = this.state;
    return (
      <Fragment>
        <div className="b-row register">
          {showAlertSuccess && (
            <AlertMessage
              linkCancel={'DONE'}
              toggle={this.hideAlert}
              text={alertTextSuccess}
            />
          )}
          {showAlertError && (
            <AlertMessage
              classAlert={classnames({
                error: true,
              })}
              text={alertTextError}
            />
          )}
          <div className="b-col-8 b-col-sm-12">
            <div className="register__left">
              <HeaderUnLoggedIn />
              <UserFormSignUp handleSubmit={this.handleRegister} trialLinkDays={this.state.link_days}/>
            </div>
          </div>
          <div className="b-col-4 b-col-sm-12 register-bg">
            <div className="register-bg__top">
              <div className="register-bg__text m-r-15">
                Already have an account?
              </div>
              <Link to={SIGN_IN_PATH} className="btn btn-white outline">
                Sign in
              </Link>
            </div>
            <div className="register-bg__inner">
              <h2 className="register-bg__title">
                You only have one link. <br /> Make it count
              </h2>
              <div className="register-bg__text">Do you have questions? </div>
              <Link to="/contact" className="btn btn-white m-t-30">
                Contact us
              </Link>
            </div>
          </div>
          <FooterRegistration />
        </div>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    auth: state.auth,
  };
}
export default connect(
  mapStateProps,
  actions,
)(SignUp);



// WEBPACK FOOTER //
// ./src/scenes/SignUp/SignUp.js